import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=2029bf6e&scoped=true"
import script from "./ClientsFilter.vue?vue&type=script&lang=ts"
export * from "./ClientsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ClientsFilter.vue?vue&type=style&index=0&id=2029bf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029bf6e",
  null
  
)

export default component.exports